module.exports = __webpack_public_path__ + "img/16-2.a6c71a42.png";